import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton} from "@mui/material";
import { forwardRef } from "react";

const CopyButton = forwardRef(({ text, ...props }: { text: string }, ref) => {
  return (
    <IconButton {...props} ref={ref as any} sx={{ ml: 1 }} onClick={() => {
      navigator.clipboard.writeText(text);
    }}>
      <ContentCopyIcon sx={{ fontSize: 16 }} />
    </IconButton>
  );
});

export default CopyButton;
